export const Marquee = () => {
  const items = [
    "Sporting de Gijón en directo",
    "Análisis táctico",
    "El Molinón hoy",
    "Crónicas ENOLFC",
    "Contenido exclusivo TikTok @ENOLFC",
    "LaLiga Hypermotion",
  ];
  const track = (ariaHidden) => (
    <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display text-2xl md:text-4xl font-bold uppercase tracking-wide text-white/90 whitespace-nowrap">
            {item}
          </span>
          <span className="mx-8 h-2.5 w-2.5 rotate-45 bg-crimson" />
        </span>
      ))}
    </div>
  );
  return (
    <div data-testid="marquee-ticker" className="relative overflow-hidden border-y border-white/10 bg-ink2 py-5">
      <div className="flex w-max animate-marquee">
        {track(false)}
        {track(true)}
      </div>
    </div>
  );
};

export default Marquee;
